



















import {
  QuestionObjective,
  QuestionSubjective,
} from '@/resource/question/question.model';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class QuestionDifficulty extends Vue {
  @Prop({ required: true })
  question: QuestionObjective | QuestionSubjective;

  get difficulties() {
    const difficulties = [...Array(this.question.difficulty).keys()].map(
      difficulty => {
        return {
          id: difficulty,
          isActive: true,
        };
      },
    );

    if (difficulties.length < 6) {
      const currentLength = difficulties.length;
      difficulties.unshift(
        ...[...Array(6 - this.question.difficulty).keys()].map(difficulty => {
          return {
            id: difficulty + currentLength,
            isActive: false,
          };
        }),
      );
    }

    return difficulties;
  }
}
